export default __webpack_public_path__ + "static/media/know-total-adv.8de1fce4.webp";